import React, { useRef } from "react";
import cx from "classnames";
import styles from "./DKStatistic.module.css";

import { useState } from "react";
import { useEffect } from "react";
import Image from "next/image";

import { motion } from "framer-motion";
import uuid from "react-uuid";
import { statisticTitle } from "../../Data/dkStatisticData";
import { statisticData } from "../../Data/dkStatisticData";
import Link from "next/link";
import HomeTitle from "../../Elements/HomeTitle/HomeTitle";

const DKStatistic = () => {
	const [activeTab, setActiveTab] = useState(1);
	const [logoList, setLogoList] = useState([]);
	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	const scrollingTab = useRef();

	const activeTabHandler = (id) => {
		try {
			if (id > 0 && id < 7) {
				setActiveTab(id);
				let parentPos = scrollingTab.current.getBoundingClientRect();
				let childPos = document
					.getElementById(`tabHeader_${id}`)
					.getBoundingClientRect();
				scrollingTab.current.scrollBy({
					top: 0,
					left: childPos.right - parentPos.right,
					behavior: "smooth",
				});
			} else {
				return;
			}
		} catch (error) {}
	};

	useEffect(() => {
		setLogoList(statisticData.filter((i) => i.id === activeTab)[0].logosList);
	}, [activeTab]);

	return (
		<div
			className={cx(
				styles.container,
				"w-100",
				"d-flex",
				"flex-column",
				"align-items-center",
				"justify-content-center",
			)}
		>
			<HomeTitle />
			<div
				className={cx(
					styles.statisticContainer,
					"d-flex",
					"flex-column",
					"align-items-center",
					"justify-content-start",
					"w-100",
				)}
			>
				<div
					className={cx(
						styles.statisticHeaderMenu,
						"d-flex",
						"align-items-center",
						"justify-content-center",
						"w-100",
					)}
				>
					<div>
						<button
							onClick={() => {
								activeTabHandler(activeTab - 1);
							}}
							className={cx(
								styles.prevBtn,
								styles.statisticHeaderMenuSrollControl,
								activeTab === 1 &&
									styles.statisticHeaderMenuSrollControlDiactive,
								"d-flex",
								"d-lg-none",
								"align-items-center",
								"justify-content-center",
								"d-lg-none",
								"p-0",
								"m-0",
							)}
							id="dkStatisticPrevStatistic"
							aria-label="prevous statisticr"
						>
							<svg
								width="13"
								height="13"
								viewBox="0 0 13 13"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M7.41417 12L11.9957 6.5368L7.41406 1"
									stroke="white"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M12 6.53516L1 6.53516"
									stroke="white"
									strokeLinecap="round"
								/>
							</svg>
						</button>
					</div>
					<div
						ref={scrollingTab}
						className={cx(
							styles.headerTabMenuWrapper,
							"d-flex",
							"flex-fill",
							"align-items-center",
							"justify-content-start",
						)}
					>
						{statisticTitle.map((itemTitle, key) => (
							<div
								id={`tabHeader_${itemTitle.id}`}
								aria-label={`number ${itemTitle.id} statistic`}
								key={uuid()}
							>
								{activeTab === itemTitle.id && styles.headerMenuButtonActive ? (
									<button
										onClick={() => activeTabHandler(itemTitle.id)}
										className={cx(
											styles.headerMenuButton,
											activeTab === itemTitle.id &&
												styles.headerMenuButtonActive,
											"d-flex",
											"align-items-center",
											"justify-content-center",
											"p-0",
											"m-0",
										)}
									>
										{itemTitle.title}
									</button>
								) : (
									<span
										onClick={() => activeTabHandler(itemTitle.id)}
										className={cx(
											styles.headerMenuButton,
											activeTab === itemTitle.id &&
												styles.headerMenuButtonActive,
											"d-flex",
											"align-items-center",
											"justify-content-center",
											"p-0",
											"m-0",
										)}
									>
										{itemTitle.title}
									</span>
								)}
							</div>
						))}
					</div>
					<div>
						<button
							onClick={() => {
								activeTabHandler(activeTab + 1);
							}}
							className={cx(
								styles.nextBtn,
								styles.statisticHeaderMenuSrollControl,
								activeTab === 6 &&
									styles.statisticHeaderMenuSrollControlDiactive,
								"d-flex",
								"d-lg-none",
								"align-items-center",
								"justify-content-center",
								"d-lg-none",
								"p-0",
								"m-0",
							)}
							id="dkStatisticNextStatistic"
							aria-label="next statisticr"
						>
							<svg
								width="13"
								height="13"
								viewBox="0 0 13 13"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M5.58583 1L1.00429 6.4632L5.58594 12"
									stroke="white"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M1 6.46484L12 6.46484"
									stroke="white"
									strokeLinecap="round"
								/>
							</svg>
						</button>
					</div>
				</div>
				<div
					className={cx(
						styles.statisticNumberContainer,
						"d-flex",
						"flex-column",
						"flex-lg-row-reverse",
						"align-items-lg-start",
						"align-items-center",
						"justify-content-lg-start",
						"justify-content-center",
						"w-100",
						"flex-lg-wrap",
					)}
				>
					{statisticData
						.filter((i) => i.id === activeTab)[0]
						.statisticList.map((item, key) => (
							<div key={key}>
								{isMounted ? (
									<motion.div
										initial={{ x: "50%", opacity: 0 }}
										animate={{ x: 0, opacity: 1 }}
										transition={{ delay: 0.1 * key, stiffness: 90 }}
										key={uuid()}
										className={cx(
											styles.statisticItemWrapper,
											"d-flex",
											"flex-column",
											"align-items-lg-end",
											"align-items-center",
											"justify-content-start",
											//   "w-100"
										)}
									>
										<h2 className={cx(styles.statisticNumber, "p-0", "m-0")}>
											{item.number}
										</h2>
										<span className={cx(styles.unitStatistic, "p-0", "m-0")}>
											{item.unit}
										</span>
										<span
											className={cx(styles.statisticDescribe, "p-0", "m-0")}
										>
											{item.describe}
										</span>
									</motion.div>
								) : (
									<div
										key={uuid()}
										className={cx(
											styles.statisticItemWrapper,
											"d-flex",
											"flex-column",
											"align-items-lg-end",
											"align-items-center",
											"justify-content-start",
											//   "w-100"
										)}
									>
										<h2 className={cx(styles.statisticNumber, "p-0", "m-0")}>
											{item.number}
										</h2>
										<span className={cx(styles.unitStatistic, "p-0", "m-0")}>
											{item.unit}
										</span>
										<span
											className={cx(styles.statisticDescribe, "p-0", "m-0")}
										>
											{item.describe}
										</span>
									</div>
								)}
							</div>
						))}
				</div>
				<div
					className={cx(
						styles.statisticLogoContainer,
						"d-flex",
						"align-items-center",
						"justify-content-center",
						"flex-wrap",
						"w-100",
					)}
				>
					{statisticData
						.filter((i) => i.id === activeTab)[0]
						.logosList.map((item, key) => (
							<div key={key}>
								{isMounted ? (
									<motion.div
										initial={{ y: "50%", opacity: 0 }}
										animate={{ y: 0, opacity: 1 }}
										transition={{ delay: 0.1 * key, stiffness: 90 }}
										key={uuid()}
										className={cx(
											styles.statisticLogoWrapper,
											"d-flex",
											"align-items-center",
											"justify-content-center",
											logoList.length === 1 && styles.span2Cell,
										)}
									>
										<motion.div
											whileHover={{
												y: -5,
												transition: {
													duration: 0.3,
													stiffness: 70,
												},
											}}
											className={cx(
												styles.eachLogoStyles,
												"d-flex",
												"align-items-center",
												"justify-content-center",
												(key === logoList.length - 1 ||
													key === logoList.length - 2) &&
													styles.eachLogoStylesNoBorderBottom,
											)}
										>
											{item.isActive ? (
												<Link target="_blank" href={item.link}>
													<Image
														width="100%"
														height="100%"
														src={item.logo}
														alt="digikala"
														// style={{transform: `translate(${item?.scale})`}}
														style={{ transform: `scale(${item?.scale})` }}
													/>
												</Link>
											) : (
												<Image
													width="100%"
													height="100%"
													src={item.logo}
													alt="digikala"
													// style={{transform: `translate(${item?.scale})`}}
													style={{ transform: `scale(${item?.scale})` }}
												/>
											)}
										</motion.div>
									</motion.div>
								) : (
									<div
										key={uuid()}
										className={cx(
											styles.statisticLogoWrapper,
											"d-flex",
											"align-items-center",
											"justify-content-center",
											logoList.length === 1 && styles.span2Cell,
										)}
									>
										<div
											className={cx(
												styles.eachLogoStyles,
												"d-flex",
												"align-items-center",
												"justify-content-center",
												(key === logoList.length - 1 ||
													key === logoList.length - 2) &&
													styles.eachLogoStylesNoBorderBottom,
											)}
										>
											{item.isActive ? (
												<Link target="_blank" href={item.link}>
													<Image
														width="100%"
														height="100%"
														src={item.logo}
														alt="digikala"
														// style={{transform: `translate(${item?.scale})`}}
														style={{ transform: `scale(${item?.scale})` }}
													/>
												</Link>
											) : (
												<Image
													width="100%"
													height="100%"
													src={item.logo}
													alt="digikala"
													// style={{transform: `translate(${item?.scale})`}}
													style={{ transform: `scale(${item?.scale})` }}
												/>
											)}
										</div>
									</div>
								)}
							</div>
						))}
				</div>
				<p className="pt-2">منبع: بر اساس داده‌های سال ۱۴۰۴</p>
			</div>
		</div>
	);
};

export default DKStatistic;
